import React from 'react';

const IconLoader = () => (
  <svg
    id="logo"
    xmlns="http://www.w3.org/2000/svg"
    width="2085"
    height="2500"
    viewBox="0 0 256 307">
    <g id="B">
      <path
        d="M249.63 171.958l-22.595-21.6-71.426-65.624-30.791 29.24c-2.815 3.83-2.624 9 .574 12.581l28.15 24.243-.097.038 30.256 28.915c3.58 3.983 3.485 9.881-.268 13.71l-81.575 77.516 37.092 35.406 110.68-105.166c8.484-8.08 8.503-21.179 0-29.298v.039z"
        fill="currentColor"
      />
      <path
        d="M6.343 134.464l22.596 21.543 71.464 65.623 30.772-29.24a9.965 9.965 0 0 0-.574-12.581l-28.15-24.281.096-.058-30.274-28.895c-3.543-3.964-3.447-9.881.287-13.692l81.575-77.553L117.043 0 6.363 105.166c-8.484 8.08-8.484 21.198 0 29.298h-.02z"
        fill="currentColor"
      />
      <circle
        id="Shape"
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
  // <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
  //   <title>Loader Logo</title>
  //   <g>
  //     <g id="B" transform="translate(11.000000, 5.000000)">
  //       <path
  //         d="M45.691667,45.15 C48.591667,46.1 50.691667,48.95 50.691667,52.2 C50.691667,57.95 46.691667,61 40.291667,61 L28.541667,61 L28.541667,30.3 L39.291667,30.3 C45.691667,30.3 49.691667,33.15 49.691667,38.65 C49.691667,41.95 47.941667,44.35 45.691667,45.15 Z M33.591667,43.2 L39.241667,43.2 C42.791667,43.2 44.691667,41.85 44.691667,38.95 C44.691667,36.05 42.791667,34.8 39.241667,34.8 L33.591667,34.8 L33.591667,43.2 Z M33.591667,47.5 L33.591667,56.5 L40.191667,56.5 C43.691667,56.5 45.591667,54.75 45.591667,52 C45.591667,49.2 43.691667,47.5 40.191667,47.5 L33.591667,47.5 Z"
  //         fill="currentColor"
  //       />
  //     </g>
  //     <path
  //       stroke="currentColor"
  //       strokeWidth="5"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //       d="M 50, 5
  //                 L 11, 27
  //                 L 11, 72
  //                 L 50, 95
  //                 L 89, 73
  //                 L 89, 28 z"
  //     />
  //   </g>
  // </svg>
);

export default IconLoader;
